import arrow from '../../../../assets/image/arrowD.svg';
import React from 'react';

const FilterRender = ({ filter, params, setParams, state, setState }) => {
	const { type, label, key, options, isCustom, handleFilter, checked } = filter;

	const toggle = () => {
		setState((prev) => ({
			...prev,
			[key]: !prev[key],
		}));
	};

	return (
		<div className="report-dropdown-container d-flex align-items-center gap-3">
			<div onClick={toggle}>
				<div className="d-flex align-items-center justify-content-center">
					{key === 'date_range' ? <div className="fs-5 fw-light">Date Range:</div> : ''}
					<div className="report-dropdown fw-bold gap-3">
						{key === 'date_range'
							? options.find((data) => data.key === params.date_range).label
							: label}
						<span
							style={{
								transform: state[key] ? 'rotate(180deg)' : 'rotate(0deg)',
							}}
						>
							<img
								src={arrow}
								alt=""
							/>
						</span>
					</div>
				</div>
				{state[key] && (
					<div className="report-dropdown-options-container">
						{type === 'dropdown' &&
							options.map((option) => (
								<div
									key={option.key}
									className="p-2 cursor-pointer"
									onClick={() => {
										setParams((prev) => ({
											...prev,
											[key]: option.key,
										}));

										if (isCustom) {
											setState((prev) => ({
												...prev,
												isCustomDateOpen: option.key === 'custom',
											}));
										}
									}}
								>
									{option.label}
								</div>
							))}

						{type === 'checkbox' &&
							options.map((option) => (
								<label
									key={option.key}
									className="d-flex gap-3 py-2 px-3 cursor-pointer"
								>
									<input
										type="checkbox"
										className="form-check-input cursor-pointer"
										checked={checked(option.key)}
										onChange={() => {
											handleFilter(option.key);
										}}
									/>
									{option.label}
								</label>
							))}
					</div>
				)}
			</div>
		</div>
	);
};

export default FilterRender;
